module.exports = __webpack_public_path__ + "static/media/IMG_20210704_151011_491.2101fa28.jpg";